"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showNotificationText = showNotificationText;
exports.default = void 0;

var _index = babelHelpers.interopRequireDefault(require("./noty/index"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

_index.default.overrideDefaults({
  theme: 'metroui',
  type: 'notification',
  closeWith: ['click', 'button'],
  timeout: 6000,
  layout: 'bottomRight'
});

var _default = _index.default;
exports.default = _default;
var TextNotification = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(TextNotification, _Component);

  function TextNotification() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, TextNotification);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(TextNotification)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "text", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "type", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "icon", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(TextNotification, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        "data-notification-type": "genericText",
        className: "notification-item new-notification-item"
      }, _react.default.createElement("div", {
        className: "notification-icon"
      }, _react.default.createElement("div", {
        className: "primary-icon material-icons",
        "data-type": this.type,
        "data-icon": this.icon
      })), _react.default.createElement("div", {
        className: "notification-body"
      }, _react.default.createElement("div", {
        className: "body-content"
      }, this.text)));
    }
  }]);
  return TextNotification;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "text", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "type", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "icon", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);

function showNotificationText(text) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
  var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'check';
  var state = {
    component: _react.default.createElement(TextNotification, {
      text: text,
      type: type,
      icon: icon
    }),
    doMark: true,
    shown: false
  };
  var noty = new _index.default({
    text: '',
    timeout: 6000,
    callbacks: {
      onShow: function onShow() {
        state.shown = true;

        _reactDom.default.render(state.component, this.barDom.querySelector('.noty_body'));
      },
      afterClose: function afterClose() {
        _reactDom.default.unmountComponentAtNode(this.barDom.querySelector('.noty_body'));
      }
    },
    visibilityControl: true
  });
  noty.show();
}